import { render, staticRenderFns } from "./alignMiddle_off.vue?vue&type=template&id=a53c368a&"
import script from "./alignMiddle_off.vue?vue&type=script&lang=ts&"
export * from "./alignMiddle_off.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports